import { useTranslation } from 'react-i18next';
import { notificationMeta } from '../notificationMeta';
import { relativeTimeTr } from '../relativeTime';
import type { AppNotification } from '../types';

interface NotificationItemProps {
  item: AppNotification;
  onSelect: (item: AppNotification) => void;
}

/** Tek bildirim satırı: tür ikonu + başlık + göreli zaman + okunmamış vurgusu. */
export function NotificationItem({ item, onSelect }: NotificationItemProps) {
  const { t } = useTranslation('notifications');
  const { Icon, color } = notificationMeta(item.type);

  return (
    <button
      type="button"
      className={`ds-notif-item${item.isRead ? '' : ' ds-notif-item--unread'}`}
      onClick={() => onSelect(item)}
      data-testid="notification-item"
    >
      <span className="ds-notif-item__icon" style={{ color }} aria-hidden="true">
        <Icon size={16} strokeWidth={1.8} />
      </span>
      <span className="ds-notif-item__body">
        <span className="ds-notif-item__title">{item.title}</span>
        {item.body ? <span className="ds-notif-item__desc">{item.body}</span> : null}
        <span className="ds-notif-item__time">{relativeTimeTr(item.createdAt)}</span>
      </span>
      {!item.isRead ? (
        <span className="ds-notif-item__dot" aria-label={t('item.unread')} />
      ) : null}
    </button>
  );
}
